import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M65.9401 37.72C65.9401 36.72 65.4501 35.84 64.7001 35.31C65.4501 34.78 65.9401 33.9 65.9401 32.9C65.9401 31.81 65.35 30.86 64.48 30.35C65.12 29.81 65.5301 29.01 65.5301 28.1C65.5301 26.87 64.7901 25.82 63.7501 25.38C64.2601 24.85 64.5701 24.13 64.5701 23.33C64.5701 21.95 63.6401 20.81 62.3801 20.48C62.7801 19.97 63.0301 19.34 63.0301 18.64C63.0301 17.11 61.8701 15.86 60.4001 15.72C60.5501 15.36 60.6401 14.97 60.6401 14.56C60.6401 12.93 59.34 11.61 57.73 11.61C57.61 11.61 57.5001 11.63 57.3901 11.64C57.4201 11.46 57.4501 11.27 57.4501 11.08C57.4501 9.45002 56.15 8.13 54.54 8.13C54.24 8.13 53.95 8.19003 53.67 8.28003C53.5 6.82003 52.28 5.67999 50.79 5.67999C50.32 5.67999 49.88 5.80001 49.48 6.01001C49.18 4.71001 48.0301 3.72998 46.6501 3.72998C46.0601 3.72998 45.51 3.91003 45.05 4.22003C44.69 3.01003 43.5901 2.13 42.2801 2.13C41.5801 2.13 40.9501 2.39 40.4501 2.81C39.9601 1.88 39.0001 1.23999 37.8901 1.23999C37.0801 1.23999 36.3501 1.58 35.8201 2.12C35.3001 1.61 34.5901 1.28998 33.8101 1.28998C33.7901 1.28998 33.7801 1.29999 33.7601 1.29999C33.7401 1.29999 33.7301 1.28998 33.7101 1.28998C32.9301 1.28998 32.2201 1.61 31.7001 2.12C31.1701 1.58 30.4401 1.23999 29.6301 1.23999C28.5201 1.23999 27.5601 1.88 27.0701 2.81C26.5701 2.39 25.9301 2.13 25.2401 2.13C23.9301 2.13 22.83 3.02003 22.47 4.22003C22.01 3.91003 21.4601 3.72998 20.8701 3.72998C19.4901 3.72998 18.34 4.70001 18.04 6.01001C17.65 5.81001 17.21 5.67999 16.73 5.67999C15.24 5.67999 14.03 6.82003 13.85 8.28003C13.57 8.19003 13.29 8.13 12.98 8.13C11.37 8.13 10.0701 9.45002 10.0701 11.08C10.0701 11.27 10.0901 11.46 10.1301 11.64C10.0201 11.63 9.91004 11.61 9.79004 11.61C8.18004 11.61 6.88007 12.93 6.88007 14.56C6.88007 14.97 6.96006 15.37 7.12006 15.72C5.65006 15.87 4.49005 17.11 4.49005 18.64C4.49005 19.34 4.74008 19.98 5.14008 20.48C3.88008 20.81 2.95007 21.95 2.95007 23.33C2.95007 24.13 3.27008 24.85 3.77008 25.38C2.72008 25.83 1.99005 26.88 1.99005 28.1C1.99005 29.01 2.40004 29.81 3.04004 30.35C2.17004 30.86 1.58008 31.8 1.58008 32.9C1.58008 33.9 2.07007 34.78 2.82007 35.31C2.07007 35.84 1.58008 36.72 1.58008 37.72C1.58008 38.75 2.11009 39.66 2.90009 40.19C2.43009 40.72 2.13007 41.41 2.13007 42.18C2.13007 43.78 3.39007 45.08 4.95007 45.12C5.47007 47.83 6.01007 49.46 6.01007 49.46L15.6901 19.16C15.6901 19.16 25.4901 17.51 33.7601 17.47C42.0301 17.5 51.8301 19.16 51.8301 19.16L61.5101 49.46C61.5101 49.46 62.0501 47.83 62.5701 45.12C64.1401 45.07 65.3901 43.78 65.3901 42.18C65.3901 41.41 65.0901 40.72 64.6201 40.19C65.4101 39.66 65.9401 38.75 65.9401 37.72Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M33.6 16.98C33.6 16.98 30.38 10.6201 22.04 4.59009"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M16.8401 6.12012C16.8401 6.12012 21.6301 8.10014 29.3901 17.0201"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M13.6501 8.68005C13.6501 8.68005 18.1601 10.5001 25.1801 17.6801"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M10.23 11.98C10.23 11.98 15.6 13.55 20.72 18.26"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M7.01001 15.9501C7.01001 15.9501 11.14 16.3601 16.18 19.0101"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M14.53 22.0601C14.53 22.0601 9.16003 20.8201 5.28003 20.9901"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M13.4501 26.2702C13.4501 26.2702 7.75012 25.5301 3.87012 25.6901"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M12.2201 30.23C12.2201 30.23 7.10014 29.57 2.89014 30.31"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M10.8901 34.61C10.8901 34.61 7.01005 34.57 2.80005 35.31"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path d="M9.65997 38.16L2.96997 40.4701" stroke={outline} strokeWidth="0.75" strokeMiterlimit="10" />
      <path
        d="M33.8101 17.0401C33.8101 17.0401 37.0301 10.6801 45.3701 4.65015"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M41.5902 2.71008C41.5902 2.71008 37.6302 5.52005 33.7502 11.3H33.7902C29.9102 5.52005 25.9502 2.71008 25.9502 2.71008"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M50.4899 6.12012C50.4899 6.12012 45.6999 8.10014 37.9399 17.0201"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M53.6801 8.68005C53.6801 8.68005 49.1701 10.5001 42.1501 17.6801"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M57.0901 11.98C57.0901 11.98 51.7201 13.55 46.6001 18.26"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M37.1901 1.58008C37.1901 1.58008 35.1901 3.29006 33.7001 5.69006C32.2101 3.30006 30.29 1.58008 30.29 1.58008"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M60.3101 15.9501C60.3101 15.9501 56.1801 16.3601 51.1401 19.0101"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M52.8 22.0601C52.8 22.0601 58.17 20.8201 62.05 20.9901"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M53.8701 26.2702C53.8701 26.2702 59.5701 25.5301 63.4501 25.6901"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M55.1101 30.23C55.1101 30.23 60.2301 29.57 64.4401 30.31"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M56.4302 34.61C56.4302 34.61 60.3102 34.57 64.5202 35.31"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path d="M57.6699 38.16L64.3599 40.4701" stroke={outline} strokeWidth="0.75" strokeMiterlimit="10" />
    </g>
  )
}
